enum DefaultMerchantFlag {
  ADMIN_BILLING_MODULE = "AdminBillingModule",
  ADMIN_CLERK_MODULE = "AdminClerkModule",
  ADMIN_USE_DASHBOARD = "AdminUseDashboard",
  ADMIN_USE_MERCHANT_ONBOARDING = "AdminUseMerchantOnboarding",
  ADMIN_USE_CLERK_ONBOARDING = "AdminUseClerkOnboarding",
}

export default DefaultMerchantFlag;
